import { createContext, type ReactNode, useContext } from "react";
import type { RuntimeConfig } from "./config";

const ConfigContext = createContext<RuntimeConfig | null>(null);

export function ConfigProvider({
  config,
  children,
}: {
  config: RuntimeConfig;
  children: ReactNode;
}) {
  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
}

/** The configuration loaded before rendering; throws outside a ConfigProvider. */
export function useRuntimeConfig(): RuntimeConfig {
  const config = useContext(ConfigContext);
  if (!config) throw new Error("useRuntimeConfig needs a ConfigProvider");
  return config;
}
